import React from "react";
import Link from "next/link";

const ShareIcons = ({ alignment, articleUrl, articleTitle }) => {
  const encodedUrl = encodeURIComponent(articleUrl);
  const encodedTitle = encodeURIComponent(articleTitle);

  return (
    <div className={alignment}>
      {/* Facebook Share */}
      <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Share on Facebook"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <g clipPath="url(#clip0_177_644)">
            <path
              d="M9 0C4.02948 0 0 4.02948 0 9C0 13.2206 2.90592 16.7623 6.82596 17.735V11.7504H4.97016V9H6.82596V7.81488C6.82596 4.75164 8.21232 3.3318 11.2198 3.3318C11.79 3.3318 12.7739 3.44376 13.1764 3.55536V6.04836C12.964 6.02604 12.595 6.01488 12.1367 6.01488C10.661 6.01488 10.0908 6.57396 10.0908 8.02728V9H13.0306L12.5255 11.7504H10.0908V17.9341C14.5472 17.3959 18.0004 13.6015 18.0004 9C18 4.02948 13.9705 0 9 0Z"
              fill="#63778B"
            />
          </g>
          <defs>
            <clipPath id="clip0_177_644">
              <rect width="18" height="18" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </a>

      {/* Twitter/X Share */}
      {/* <a
        href={`https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Share on Twitter"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="16"
          viewBox="0 0 18 16"
          fill="none"
        >
          <path
            d="M13.7445 0.427979H16.2746L10.747 6.7456L17.2498 15.3425H12.1582L8.17028 10.1285L3.60722 15.3425H1.07558L6.98783 8.58505L0.749756 0.427979H5.97059L9.5753 5.19373L13.7445 0.427979ZM12.8565 13.8281H14.2584L5.2088 1.86283H3.70435L12.8565 13.8281Z"
            fill="#63778B"
          />
        </svg>
      </a> */}

      {/* WhatsApp Share */}
      <a
        href={`https://api.whatsapp.com/send?text=${encodedUrl}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Share on WhatsApp"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
        >
          <g clipPath="url(#clip0_201_2030)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.496 2.47047C12.9051 0.878221 10.7893 0.000894949 8.53513 0C3.89051 0 0.110356 3.77871 0.108497 8.42336C0.107877 9.90803 0.495918 11.3573 1.23329 12.6347L0.0378418 17L4.50492 15.8286C5.73569 16.4997 7.12144 16.8533 8.53176 16.8539H8.53523C13.1794 16.8539 16.9599 13.0748 16.9617 8.43008C16.9626 6.17921 16.087 4.06273 14.496 2.47047ZM8.53523 15.4312H8.53236C7.27562 15.4307 6.04295 15.0932 4.96764 14.4552L4.71186 14.3035L2.06107 14.9986L2.76863 12.4149L2.60208 12.1501C1.90099 11.0353 1.53069 9.7468 1.53124 8.42388C1.53277 4.56344 4.67471 1.42274 8.538 1.42274C10.4087 1.42345 12.1672 2.1527 13.4896 3.47612C14.8119 4.79954 15.5397 6.55869 15.539 8.42953C15.5374 12.2902 12.3955 15.4312 8.53523 15.4312ZM12.377 10.1874C12.1664 10.082 11.1312 9.57279 10.9382 9.50255C10.7452 9.43231 10.6049 9.3972 10.4645 9.60792C10.3242 9.81863 9.92065 10.2927 9.79779 10.4332C9.675 10.5737 9.55219 10.5913 9.34162 10.4859C9.13108 10.3805 8.45266 10.1583 7.64842 9.44119C7.02253 8.88311 6.59993 8.19377 6.47712 7.98306C6.3543 7.77234 6.46406 7.6584 6.56946 7.55349C6.66416 7.45917 6.78 7.30765 6.88528 7.18472C6.99054 7.06182 7.02563 6.97402 7.0958 6.83356C7.166 6.69307 7.13091 6.57014 7.07827 6.46479C7.02563 6.35944 6.60457 5.32341 6.42909 4.90198C6.2582 4.49154 6.0846 4.54708 5.95536 4.54065C5.83268 4.53455 5.69218 4.53324 5.55183 4.53324C5.41146 4.53324 5.18337 4.58593 4.99035 4.79663C4.79737 5.00736 4.25347 5.51658 4.25347 6.55259C4.25347 7.5886 5.00791 8.58947 5.11319 8.72996C5.21845 8.87044 6.59787 10.9965 8.70999 11.9082C9.21234 12.1251 9.60453 12.2546 9.9103 12.3516C10.4147 12.5118 10.8737 12.4892 11.2365 12.435C11.641 12.3746 12.4822 11.9258 12.6577 11.4341C12.8331 10.9425 12.8331 10.521 12.7805 10.4332C12.7279 10.3454 12.5875 10.2927 12.377 10.1874Z"
              fill="#63778B"
            />
          </g>
          <defs>
            <clipPath id="clip0_201_2030">
              <rect width="17" height="17" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </a>

      {/* LinkedIn Share */}
      <a
        href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}&title=${encodedTitle}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Share on LinkedIn"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
        >
          <path
            d="M15.7416 0H1.25508C0.561133 0 0 0.547852 0 1.2252V15.7715C0 16.4488 0.561133 17 1.25508 17H15.7416C16.4355 17 17 16.4488 17 15.7748V1.2252C17 0.547852 16.4355 0 15.7416 0ZM5.04355 14.4865H2.52012V6.37168H5.04355V14.4865ZM3.78184 5.26602C2.97168 5.26602 2.31758 4.61191 2.31758 3.80508C2.31758 2.99824 2.97168 2.34414 3.78184 2.34414C4.58867 2.34414 5.24277 2.99824 5.24277 3.80508C5.24277 4.60859 4.58867 5.26602 3.78184 5.26602ZM14.4865 14.4865H11.9664V10.542C11.9664 9.60234 11.9498 8.39043 10.6549 8.39043C9.34336 8.39043 9.14414 9.41641 9.14414 10.4756V14.4865H6.62734V6.37168H9.04453V7.48066H9.07773C9.41308 6.84316 10.2365 6.16914 11.4617 6.16914C14.015 6.16914 14.4865 7.84922 14.4865 10.034V14.4865Z"
            fill="#63778B"
          />
        </svg>
      </a>

      
    </div>
  );
};

export default ShareIcons;